import React from 'react';
import { isNative } from '../utils/platformUtils';

const PlatformButton = ({ 
  children, 
  onClick, 
  disabled = false, 
  variant = 'primary',
  size = 'medium',
  className = '',
  ...props 
}) => {
  // Build CSS class name for ALL platforms using token-based classes
  const getClassName = () => {
    const baseClass = `button-${variant}`;
    const sizeClass = size !== 'medium' ? `size-${size}` : '';
    const disabledClass = disabled ? 'disabled' : '';
    
    return [baseClass, sizeClass, disabledClass, className]
      .filter(Boolean)
      .join(' ');
  };

  // Minimal inline styles for ALL platforms
  const getInlineStyles = () => {
    const styles = {};
    
    // Only add platform-specific styles that CANNOT be handled by CSS
    if (isNative()) {
      styles.cursor = 'default'; // Native platforms don't have cursor
    }
    
    return { ...styles, ...props.style };
  };

  // Platform-specific click handlers
  const handleClick = (e) => {
    if (disabled) return;
    
    // Add platform-specific click effects
    if (isNative()) {
      // Native platforms don't need hover effects
      onClick?.(e);
    } else {
      // Web platforms can have hover effects
      onClick?.(e);
    }
  };

  return (
    <button
      className={getClassName()}
      style={getInlineStyles()}
      onClick={handleClick}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
};

export default PlatformButton; 